function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PaginationBasic from '@/components/PaginationBasic.vue';
import PaginationFirestore from '@/components/PaginationFirestore.vue';
import { ALL_TABLES_OPTION, envConfig, textsDefaul, TYPE_CHANGE_METADA } from '@/js/constants';
import my_access_service from '@/apps/data-platform/services/tables_views/my_access_service';
import assignments_service from '@/apps/data-platform/services/tables_views/assignments_service';
import utils from '@/js/utils';
import DialogsComponent from '@/components/DialogsComponent.vue';
import FormMetadataTableComponent from '@/apps/data-platform/components/FormMetadataTableComponent.vue';
import FormAccessRequestTableComponent from '../../../components/FormAccessRequestTableComponent.vue';
import StateComponent from '@/components/StateComponent.vue';
export default {
  name: 'ContMyAccessComponent',
  components: {
    PaginationBasic: PaginationBasic,
    PaginationFirestore: PaginationFirestore,
    DialogsComponent: DialogsComponent,
    FormMetadataTableComponent: FormMetadataTableComponent,
    FormAccessRequestTableComponent: FormAccessRequestTableComponent,
    StateComponent: StateComponent
  },
  props: {
    filter_enabled: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      MODAL_NAME_METADATA_VIEW: 'dialogMetadata',
      MODAL_NAME_METADATA: 'dialogMetadataChange',
      MODAL_REQUEST_ACCESS: 'dialogRequestAccess',
      TYPE_CHANGE_METADA: TYPE_CHANGE_METADA,
      collapse_filter: false,
      choose_domain: null,
      defaultDomain: ALL_TABLES_OPTION,
      items: [],
      serverItems: [],
      filter: '',
      filterOn: [],
      tplToUpdate: {},
      lazyLoadParamsForViewer: null,
      pagination: {
        current: 1,
        limit: envConfig.pagintaionSize,
        cursors: [null],
        next: false,
        total: 0
      },
      key_pagination: 1,
      loadingPage: false,
      nextCursor: null,
      currentPage: 1,
      perPage: envConfig.pagintaionSize
    };
  },
  created: function created() {
    this.choose_domain = this.defaultDomain;
    // this.getAccess()
  },
  watch: {
    choose_domain: function choose_domain(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.fetchPage(true);
      }
    }
  },
  methods: {
    copyviewid: function copyviewid(link) {
      var aux = link.replace(":", ".");
      navigator.clipboard.writeText(aux);
      this.$toast.success("ID copiado");
    },
    copyAccessLink: function copyAccessLink(link) {
      navigator.clipboard.writeText(link);
    },
    onSearch: function onSearch(filter) {
      this.filter = filter.text_filter;
      this.choose_domain = filter.choose_domain;
      this.fetchPage(true);
    },
    onCleanSearch: function onCleanSearch() {
      this.filter = "";
      this.choose_domain = ALL_TABLES_OPTION;
      this.fetchPage(true);
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    changePage: function changePage(page) {
      this.pagination.current = page;
      this.fetchPage();
    },
    fetchPage: function () {
      var _fetchPage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this = this;
        var reset,
          index,
          cursor,
          allDomains,
          domain,
          params,
          response,
          tables,
          detailParams,
          _args = arguments;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              reset = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
              this.loadingPage = true;
              if (reset) {
                this.pagination.current = 1;
                this.pagination.cursors = [null];
                this.key_pagination++;
              }
              index = this.pagination.current - 1;
              cursor = this.pagination.cursors[index];
              allDomains = true;
              domain = null;
              if (this.choose_domain !== ALL_TABLES_OPTION) {
                allDomains = false;
                domain = this.choose_domain;
              }
              params = {
                allDomains: allDomains,
                domain: domain,
                limit: this.pagination.limit,
                cursor: cursor,
                text_filter: this.filter || null
              };
              _context.p = 1;
              _context.n = 2;
              return my_access_service.getMyAccess(params);
            case 2:
              response = _context.v;
              this.serverItems = response.data.items || response.data || [];
              this.items = this.serverItems;
              this.nextCursor = response.data.nextCursor || response.data.next_page_token || null;
              this.pagination.total = -1;
              if (this.nextCursor && !this.pagination.cursors[this.pagination.current]) {
                this.pagination.cursors[this.pagination.current] = this.nextCursor;
              }
              this.pagination.next = !!this.nextCursor;

              // Enriquecer con detalles de tablas
              if (this.serverItems.length > 0) {
                tables = [];
                this.serverItems.forEach(function (item) {
                  tables.push({
                    projectId: item.table.projectId,
                    datasetId: item.table.datasetId,
                    tableId: item.table.objectId,
                    domain_table: item.domain,
                    source: item.source ? item.source : "bigquery"
                  });
                });
                detailParams = {
                  'tables': tables
                };
                assignments_service.getTablesDetails(detailParams).then(function (response2) {
                  var tables_metadata = response2.data;
                  _this.serverItems = _this.serverItems.map(function (item) {
                    var temp = Object.assign({}, item);
                    var table = temp.table;
                    if (tables_metadata[table.id]) {
                      temp.numRows = tables_metadata[table.id].numRows || '0';
                    }
                    return temp;
                  });
                  _this.serverItems.map(function (item) {
                    if (tables_metadata[item.table.id]) {
                      var columns = tables_metadata[item.table.id].schema ? tables_metadata[item.table.id].schema.fields : [];
                      var map_columns = {};
                      columns.forEach(function (x) {
                        map_columns[x.name.toLowerCase()] = x;
                      });
                      if (item.last_version && item.last_version.columns) {
                        var contadorDiferentes = 0;
                        item.last_version.columns.forEach(function (x) {
                          if (!(x.toLowerCase() in map_columns)) {
                            contadorDiferentes++;
                          }
                        });
                        item.columns_change = contadorDiferentes > 0;
                      }
                    }
                  });
                  _this.items = _this.serverItems;
                });
              }
            case 3:
              _context.p = 3;
              this.loadingPage = false;
              return _context.f(3);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1,, 3, 4]]);
      }));
      function fetchPage() {
        return _fetchPage.apply(this, arguments);
      }
      return fetchPage;
    }(),
    generateViewUrl: function generateViewUrl(item) {
      console.log(item);
      window.open(item.view_url, '_blank');
    },
    openModalEdit: function openModalEdit(item, modalName) {
      var _this2 = this;
      var rowData = utils.cloneJSON(item);
      var table = item.table;
      rowData.tableReference = {
        datasetId: table.datasetId,
        projectId: table.projectId,
        tableId: table.objectId
      };
      rowData.domain_table = rowData.domain;
      rowData.endDate = rowData.permissionExpirationDate;
      var relative_resourcename = "projects/" + table.projectId + "/locations/us/entryGroups/@bigquery/entries/bigquery.googleapis.com/projects/" + table.projectId + "/datasets/" + table.datasetId + "/tables/" + table.objectId;
      rowData.relativeResourceName = relative_resourcename;
      // For VIEWER_ONLY mode, use separate endpoint for table metadata
      if (modalName === this.MODAL_NAME_METADATA_VIEW) {
        return this.openViewTpl(item, modalName, rowData, relative_resourcename);
      }
      var params = {
        relativeResourceName: relative_resourcename,
        //item.relativeResourceName,
        domain_table: item.domain,
        source: item.source ? item.source : "bigquery",
        tableId: table.objectId,
        datasetId: table.datasetId,
        projectId: table.projectId
      };
      console.log("log", item);
      //appApis
      //  .listTagEntry(params)
      assignments_service.getListTagEntry(params).then(function (response) {
        if (response && response.code === 200) {
          var responseTPL = response.data;
          for (var i = 0; i < responseTPL.objects.tags.length; i++) {
            if (!responseTPL.objects.tags[i].fields.business_term) {
              if (responseTPL.objects.tags[i].column) {
                responseTPL.objects.tags[i].fields.business_term = {};
                responseTPL.objects.tags[i].fields.business_term.displayName = 'Business Term';
                responseTPL.objects.tags[i].fields.business_term.stringValue = '';
              }
            }
          }
          _this2.tplToUpdate = responseTPL;
          _this2.tplToUpdate.item = rowData;
          _this2.tplToUpdate.tipo = 'edicion';
          _this2.tplToUpdate.origin = 'mytables';
          //this.$bvModal.show(modalName)
          _this2.$refs[modalName].onOpen();
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    openViewTpl: function openViewTpl(item, modalName, rowData, relativeResourceName) {
      var _this3 = this;
      // VIEWER_ONLY mode - use getListTagEntry

      var params = {
        relativeResourceName: relativeResourceName,
        domain_table: item.domain,
        source: item.source ? item.source : "bigquery",
        tableId: item.table.objectId,
        datasetId: item.table.datasetId,
        projectId: item.table.projectId
      };
      assignments_service.getListTagEntry(params).then(function (response) {
        if (response && response.code === 200) {
          var responseTPL = response.data;
          for (var i = 0; i < responseTPL.objects.tags.length; i++) {
            if (!responseTPL.objects.tags[i].fields.business_term) {
              if (responseTPL.objects.tags[i].column) {
                responseTPL.objects.tags[i].fields.business_term = {};
                responseTPL.objects.tags[i].fields.business_term.displayName = 'Business Term';
                responseTPL.objects.tags[i].fields.business_term.stringValue = '';
              }
            }
          }
          _this3.tplToUpdate = responseTPL;
          _this3.tplToUpdate.item = rowData;
          _this3.tplToUpdate.tipo = 'edicion';
          _this3.tplToUpdate.origin = 'mytables';
          _this3.$refs[modalName].onOpen();
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    sendRequest: function sendRequest() {
      //this.$bvModal.hide(this.MODAL_REQUEST_ACCESS)
      this.$refs[this.MODAL_REQUEST_ACCESS].onClose();
      return true;
    },
    saveTags: function saveTags() {
      //this.$bvModal.hide(this.MODAL_NAME_METADATA)
      this.$refs[this.MODAL_NAME_METADATA].onClose();
      this.getAccess();
      return true;
    }
  },
  computed: {
    tableFields: function tableFields() {
      return [{
        text: this.traductor('my_objects.tablas_objects.table'),
        value: 'table.id',
        sortable: true,
        class: 'text-left w-30'
      }, {
        text: this.traductor('my_objects.tablas_objects.columns'),
        value: 'columns',
        class: 'w-15',
        align: 'center'
      }, {
        text: this.traductor('my_objects.tablas_objects.rows'),
        value: 'numRows',
        class: 'w-15 text-center',
        align: 'center'
      }, {
        text: this.traductor('my_objects.tablas_objects.creation_date'),
        value: 'creationTime',
        class: 'w-15',
        align: 'center'
      }, {
        text: this.traductor('my_objects.tablas_objects.expiration_date'),
        value: 'permissionExpirationDate',
        class: 'w-15',
        align: 'center'
      }, {
        text: this.traductor('my_objects.tablas_objects.actions'),
        value: 'actions',
        class: 'text-left w-20',
        align: 'left'
      }];
    },
    isEmptyTable: function isEmptyTable() {
      return this.serverItems.length === 0;
    },
    rows: function rows() {
      return this.serverItems.length;
    },
    processd_list_domains: function processd_list_domains() {
      var list_domains = [];
      list_domains = window.userInfo ? Object.values(window.userInfo.listOrgs) : [];
      list_domains.unshift(window.userInfo.domain);
      list_domains.unshift(ALL_TABLES_OPTION);
      return list_domains;
    },
    classExpirationDate: function classExpirationDate() {
      return function (item) {
        var days = item.days_to_expire;
        return {
          'font-weight-bold': days <= 0 || days <= 7,
          'text-danger': days <= 0,
          'text-warning': days > 0 && days <= 7
        };
      };
    },
    classColumnsChange: function classColumnsChange() {
      return function (item) {
        return {
          'font-weight-bold text-danger': item.columns_change
        };
      };
    }
  }
};